import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FileText, Users, LayoutDashboard, Calendar, ClipboardCheck,
  ShieldCheck, Mail, LogOut, ChevronRight, Sparkles
} from 'lucide-react';

const Item = ({ icon: Icon, label, onClick, color, testId }) => (
  <button
    onClick={onClick}
    data-testid={testId}
    className="w-full bg-white border border-gray-200 rounded-xl p-3 flex items-center gap-3 active:bg-gray-50"
  >
    <div className={`w-9 h-9 rounded-lg ${color} flex items-center justify-center flex-shrink-0`}>
      <Icon className="w-4.5 h-4.5 text-white" />
    </div>
    <span className="flex-1 text-left text-sm font-medium text-gray-900">{label}</span>
    <ChevronRight className="w-4 h-4 text-gray-400" />
  </button>
);

export const AppMore = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    if (!window.confirm('Sign out?')) return;
    sessionStorage.removeItem('admin_password');
    navigate('/app/login', { replace: true });
  };

  return (
    <div className="pb-6">
      <div
        className="bg-gradient-to-br from-teal-600 to-cyan-700 text-white pb-5 px-5 rounded-b-3xl"
        style={{ paddingTop: 'calc(env(safe-area-inset-top) + 24px)' }}
      >
        <h1 className="text-xl font-bold">More</h1>
        <p className="text-xs text-teal-100 mt-0.5">All Pawsome Admin tools</p>
      </div>

      <div className="px-4 -mt-2 space-y-4">
        {/* Business */}
        <div>
          <h2 className="text-[11px] font-bold uppercase tracking-wider text-gray-500 mb-2 px-1">Business</h2>
          <div className="space-y-2">
            <Item icon={FileText} label="Quotes" color="bg-cyan-600" onClick={() => navigate('/admin/quotes')} testId="more-quotes" />
            <Item icon={Users} label="Clients" color="bg-sky-600" onClick={() => navigate('/admin/clients')} testId="more-clients" />
            <Item icon={Calendar} label="Relocation Tracker" color="bg-teal-600" onClick={() => navigate('/admin/tracker')} testId="more-tracker" />
            <Item icon={ClipboardCheck} label="Documents" color="bg-emerald-600" onClick={() => navigate('/admin/documents')} testId="more-documents" />
            <Item icon={ClipboardCheck} label="Meeting Summaries" color="bg-teal-600" onClick={() => navigate('/admin/meeting-summaries')} testId="more-meeting-summaries" />
            <Item icon={ShieldCheck} label="TravelSafe Reports" color="bg-violet-600" onClick={() => navigate('/admin/travelsafe')} testId="more-travelsafe" />
          </div>
        </div>

        {/* Website */}
        <div>
          <h2 className="text-[11px] font-bold uppercase tracking-wider text-gray-500 mb-2 px-1">Website Content</h2>
          <div className="space-y-2">
            <Item icon={LayoutDashboard} label="Full Admin Dashboard" color="bg-gray-700" onClick={() => navigate('/admin/dashboard')} testId="more-full-admin" />
            <Item icon={Sparkles} label="Partners, FAQs, Testimonials" color="bg-indigo-600" onClick={() => navigate('/admin/dashboard')} testId="more-content" />
            <Item icon={Mail} label="Consultation Requests" color="bg-pink-600" onClick={() => navigate('/admin/consultations')} testId="more-consultations" />
          </div>
        </div>

        {/* Session */}
        <div>
          <h2 className="text-[11px] font-bold uppercase tracking-wider text-gray-500 mb-2 px-1">Session</h2>
          <button
            onClick={handleLogout}
            className="w-full bg-white border border-red-200 text-red-600 rounded-xl p-3 flex items-center gap-3 active:bg-red-50"
            data-testid="more-logout"
          >
            <LogOut className="w-4.5 h-4.5" />
            <span className="flex-1 text-left text-sm font-medium">Sign out</span>
          </button>
        </div>

        <p className="text-center text-[11px] text-gray-400 pt-4">
          Pawsome Ventures Admin · v1.0
        </p>
      </div>
    </div>
  );
};
